import styled from '@emotion/styled';
import { DialogContent, DialogContentText, DialogTitle, Link, Typography } from '@mui/material';

export const Title = styled(DialogTitle)`
  display: flex;
  justify-content: center;
`;

export const Content = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
`;

export const ContentText = styled(DialogContentText)`
  text-align: justify;
`;

export const ContentItem = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ContentHeading = styled(Typography)``;

export const DownloadableItem = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  width: fit-content;
`;
